import { React, useEffect, useState }  from "react";
import { useParams, useLocation } from 'react-router-dom';
import Loader from "./Loader";
import moment from "moment";
import { PortableText } from "@portabletext/react";
import createClient from '../Client';
import {Footer } from "../components";

const serializers = {

  marks: {

    link: ({children, value}) => {

      const rel = !value.href.startsWith('/') ? 'noreferrer noopener' : undefined

      const target = '_blank'
      const className = 'link'

      return (

        <a href={value.href} rel={rel} target={target} className={className}>

          {children}

        </a>

      )

    },

  },

};
//news detail page
const NewsSinglePost=(setLoading, footerData, items ) => {
  const[blogContentItem, setblogContentItem] = useState([])
    const params = useParams();
    const location = useLocation();
    const slugId = location.pathname.split('news/')[1];

    // const [loading, setLoading] = useState(true);
    const [loadingNews, setLoadingNews] = useState(true); 

  useEffect(() => {
    
    // setTimeout(() => {
      setLoading(false);
    // }, 300); 
  }, []);

  
    useEffect(() => {
        window.scrollTo(0, 0);
      }, [location]);

      useEffect(() => {
        setLoading(true); 
        createClient.fetch(`*[_type == 'news' && news_slug.current == "${slugId}"][0]{
        "id": _id,
        "image":news_featured_image.asset->url,
        "metaDate": news_release_date,
        "blogTitle":news_title,
        "blogDesc": news_description,
        "blogSlug": news_slug.current,
        "blogBannerImage":news_banner_image.asset->url,
        "blogbannerImageEnable":news_banner_check,
        }
          `).then((data) => {
            setblogContentItem(data);
            setLoadingNews(false); // Local loading complete
                setLoading(false); 
          })
        .catch((error) => {
          console.error(error);
          setLoadingNews(false); // Make sure the loader dissapears even on error
          setLoading(false);
      });
        // catch(console.error);
      
    }, [slugId, setLoading]);

    if (loadingNews) {
      return <Loader />; // Use local loading state
  }
    return (
       
       
       <>
       {/* {loading && <Loader />} */}
       {blogContentItem.blogbannerImageEnable ?
          <div className="container-fluid p-0">
            <div className='col-12'> 
              <div className='row banner-wrapper-container' style={{ backgroundImage: `url(${blogContentItem.blogBannerImage})` }}>
              <div className="container banner-title-wrapper">
                <h2 className="heading-title">News</h2>
              </div>
              </div>
            </div>
          </div>
        
        :""}
       <section className="about news-detail-page" >
            <div className="container">
                <div className="row align-items-center text-center-xs">
                    <div className="col-12 col-lg-12">
                      <img className="img-fluid" src={blogContentItem.image} />
                        <div className="heading mb-40">
                            <p className="heading-subtitle">{moment(blogContentItem.metaDate).format('DD MMMM YYYY')}</p>
                            <h2 className="heading-title">{blogContentItem.blogTitle}</h2>
                            <span className="heading-desc"> <PortableText value={blogContentItem.blogDesc} components={serializers} ></PortableText></span>
                        </div>
                    </div>
                </div>
            </div>
        </section>
         {!setLoadingNews && <Footer footerData={footerData} items={items}></Footer>}
       </>
        
    );
}
export default NewsSinglePost;